import React from 'react';

const DesainLevelInteraktifScratch: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Salah satu kesalahan umum pembuat game pemula di platform Scratch adalah menciptakan level pertama yang terlalu sulit atau bahkan membingungkan tanpa panduan yang jelas. Akibatnya, pemain cenderung cepat merasa frustrasi dan meninggalkan permainan sebelum mencapai keseruan utama.
      </p>

      <p className="mb-4">
        Dalam perancangan game edukatif, prinsip <b>Level Design</b> yang baik menuntut kurva kesulitan bertahap (<i>progressive difficulty curve</i>), di mana pemain diajarkan mekanisme dasar terlebih dahulu di lingkungan yang aman sebelum dihadapkan pada rintangan kompleks.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Metodologi Desain Level 4 Tahap (Kishotenketsu)
      </h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Pengenalan (Introduction):</strong> Menampilkan mekanisme baru tanpa adanya bahaya musuh (misalnya tombol lompat untuk mengambil koin pertama).
        </li>
        <li>
          <strong>Pengembangan (Development):</strong> Menguji kemampuan pemain dengan menghadirkan rintangan sederhana yang memanfaatkan mekanisme tersebut.
        </li>
        <li>
          <strong>Variasi & Kejutan (Twist):</strong> Menggabungkan mekanisme tadi dengan elemen baru, seperti platform yang bergerak atau batas waktu.
        </li>
        <li>
          <strong>Penutupan / Penguasaan (Conclusion):</strong> Menghadirkan tantangan pamungkas yang memberikan kepuasan bagi pemain setelah berhasil menuntaskan level.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Teknik Transisi Layar Dinamis
      </h2>
      <p className="mb-4">
        Untuk berpindah dari satu level ke level berikutnya, gunakan blok penyiaran pesan <code>broadcast &quot;next_level&quot;</code>. Ketika pesan ini diterima oleh backdrop dan sprite rintangan, mereka akan berganti kostum dan me-reset posisi karakter utama ke titik awal panggung (<i>checkpoint</i>) secara otomatis.
      </p>

      <p className="mb-4">
        Level game yang dirancang dengan cermat dan penuh empati terhadap pemain akan menghasilkan pengalaman bermain yang berkesan dan mendidik bagi siapa pun yang mencobanya.
      </p>
    </div>
  );
};

export default DesainLevelInteraktifScratch;
